import { media, styled } from '@styles';

export const Accordion = styled.div`
  ${media.smallScreen`
    width: 83vw;
  `}
`;

export const AccordionItem = styled.div`
  &.disabled > button {
    color: ${(props) => props.theme.colors.disabled};
    cursor: default;
  }
`;

export const Header = styled.button`
  color: ${(props) => props.theme.colors.baseFontColorOpacityLight};
  transition: color 0.8s;
  font-size: ${(props) => props.theme.typography.h3FontSize};
  font-family: ${(props) => props.theme.typography.thinFontFamily};
  line-height: 1.1em;
  display: block;
  padding: ${({ theme: { spacing } }) =>
    `${spacing.spacer} ${spacing.spacer} ${spacing.spacer} 0`};
  position: relative;
  width: 100%;
  text-align: left;

  &:before,
  &:after {
    content: '';
    display: block;
    position: absolute;
    background-color: ${(props) => props.theme.colors.blueLight};
    transition: background-color 0.6s, opacity 0.4s, transform 0.4s;
  }
  &:before {
    width: 2px;
    height: 24px;
    top: 50%;
    margin-top: -12px;
    right: 11px;
    ${media.largeScreen`
      height: 20px;
      right: 9px;
      margin-top: -10px;
    `}
    ${media.smallScreen`
      height: 12px;
      right: 5px;
      margin-top: -6px;
    `}
  }
  &:after {
    height: 2px;
    width: 24px;
    top: 50%;
    margin-top: -1px;
    right: 0;
    ${media.largeScreen`
      width: 20px;
    `}
    ${media.smallScreen`
      width: 12px;
    `}
  }
  * {
    font: inherit;
    line-height: inherit;
    color: inherit;
  }
  &:hover {
    color: ${(props) => props.theme.colors.baseFont};
    ${media.smallScreen`
      color: ${(props) => props.theme.colors.baseFontColorOpacityLight};
    `}
  }
  &.expanded {
    color: ${(props) => props.theme.colors.red};
    &:after {
      background-color: ${(props) => props.theme.colors.red};
    }
    &:before {
      transform: rotate(90deg);
      opacity: 0;
      background-color: $red;
    }
  }
`;

export const Body = styled.div`
  overflow: hidden;
  transition: max-height 0.8s;
  will-change: max-height;
  font-size: ${(props) => props.theme.typography.baseFontSize};
  font-family: ${(props) => props.theme.typography.extraFontFamily};
  line-height: 1.6em;
  &.collapsed {
    overflow: hidden;
    max-height: 0;
    transition: all 0.5s cubic-bezier(0, 1, 0.3, 1) -100ms;
  }
  &.expanded {
    max-height: 2000px;
    transition: all 0.5s cubic-bezier(1, 0.15, 1, 1);
  }
`;
